export default __webpack_public_path__ + "static/media/group-8467.15daa0b3.png";